export default "__VITE_ASSET__Dsd2rDkl__"